// src/pages/Swap/components/SwapHeader.js
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * SwapHeader component displays the network and wallet information
 */
const SwapHeader = ({ currentChain, currentWallet }) => {
  const { t } = useTranslation();

  // Helper function to truncate wallet address
  const truncateAddress = (address) => {
    if (!address) return '';
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  return (
    <>
      {/* Display current chain at top-right */}
      <div className="swap-header-right network-pill">
        <span className="network-label">
          {currentChain?.name || t('swap.networkLabel')}
        </span>
      </div>

      {/* Display current wallet at top-left */}
      {currentWallet && (
        <div className="swap-header-left wallet-pill">
          <span className="wallet-label">
            {currentWallet.name || truncateAddress(currentWallet.address)}
          </span>
        </div>
      )}

      <h2 className="swap-title">{t('swap.title')}</h2>
    </>
  );
};

export default SwapHeader;